export const business = {
  name: 'Triple D Welding & Fabrication',
  shortName: 'Triple D',
  tagline: 'Built Strong. Welded Right.',
  owner: 'Jason DeLong',
  ownerTitle: 'Owner / Certified Welder',
  phone: '(254) 627-0732',
  phoneHref: 'tel:+12546270732',
  email: 'jmoneybbb@gmail.com',
  facebook: 'Jason Delong',
  facebookHref: 'https://facebook.com',
  hours: 'Mon–Sat, 7am – 7pm · Emergency repairs available',
  base: 'Central Texas',
  established: '2016'
}

export const nav = [
  { label: 'Services', href: '#services' },
  { label: 'Our Work', href: '#work' },
  { label: 'Process', href: '#process' },
  { label: 'Service Area', href: '#areas' },
  { label: 'Contact', href: '#contact' }
]

export const images = {
  logo: 'https://cdn.magicpatterns.com/uploads/o9Bs7zAqPm3zz2fxCbT6g1/image.png',
  card: 'https://cdn.magicpatterns.com/uploads/edwxyTxMX3GqBmyBVdLUHP/ME3ddeea7eaf9daef3c8fa244247697656.png',
  gate: 'https://cdn.magicpatterns.com/uploads/pweyadEJLS4kXwKtm95M6M/ME6a791ddac1995e01645a7a657b2fd889.jpg',
  weldTee: 'https://cdn.magicpatterns.com/uploads/taxjXYFaAfu4oJfKGG3Mhe/ME6af2438383026b1dc1794298bf248d45.jpg',
  bucket: 'https://cdn.magicpatterns.com/uploads/gqNyWLvmFeL5qhw7VPYYEd/ME9da18fc3bccbafbbf91a339ab3e78ccb.png',
  weldElbow: 'https://cdn.magicpatterns.com/uploads/b44L6QwKaWDsgYQA7iHRY8/ME39a16c960324b66db433bf1f18f8c808.jpg',
  railing: 'https://cdn.magicpatterns.com/uploads/aziBm6kmMumqrDPpZfqJCX/ME462ddedffcffd82fcf94c0c197a34020.png',
  weldBead: 'https://cdn.magicpatterns.com/uploads/rp2cL7YnxgnZNUupfd3EGZ/MEa1116db5201e26182d37a67a6599884a.jpg'
}

/** Headline specialties promoted in the hero. */
export const heroSpecialties: { title: string; icon: 'fence' | 'gate' | 'entry' | 'carport' }[] = [
  { title: 'Fencing', icon: 'fence' },
  { title: 'Entryways', icon: 'entry' },
  { title: 'Gates', icon: 'gate' },
  { title: 'Carports', icon: 'carport' }
]

export type Service = {
  number: string
  title: string
  description: string
  icon: 'truck' | 'tractor' | 'fence' | 'warehouse' | 'gate' | 'wrench'
  points: string[]
}

/* PLACEHOLDER CONTENT — swap in Triple D's final service copy. */
export const services: Service[] = [
  {
    number: '01',
    title: 'Fencing & Pipe Fence',
    description:
      'Pipe, cable, and continuous fence built to hold livestock and stand up to Texas weather for decades.',
    icon: 'fence',
    points: ['Pipe & cable fence', 'Continuous panel fence', 'Corner & brace sets']
  },
  {
    number: '02',
    title: 'Entryways & Custom Gates',
    description:
      'One-off ranch entries, driveway gates, and walk gates fabricated from your idea or ours — cut, welded, and set square.',
    icon: 'gate',
    points: ['Ranch entry frames', 'Driveway & walk gates', 'Custom lettering & brands']
  },
  {
    number: '03',
    title: 'Carports & Metal Structures',
    description:
      'Carports, lean-tos, and equipment covers engineered from square tube and purlin, built on site and anchored right.',
    icon: 'warehouse',
    points: ['Carports & lean-tos', 'RV & equipment covers', 'Slab or pier anchoring']
  },
  {
    number: '04',
    title: 'Mobile Welding',
    description:
      'Fully equipped rig comes to your property, jobsite, or pasture. Stick, MIG, and flux-core repairs done on the spot — no hauling, no downtime.',
    icon: 'truck',
    points: ['On-site rig & generator', 'Same-week scheduling', 'Structural & light repair']
  },
  {
    number: '05',
    title: 'Farm Equipment Repair',
    description:
      'Cracked buckets, bent implements, broken hitches, and worn bucket teeth rebuilt stronger than stock so you get back in the field fast.',
    icon: 'tractor',
    points: ['Bucket & tooth rebuilds', 'Implement reinforcement', 'Hitch & frame repair']
  },
  {
    number: '06',
    title: 'Barn Repair & Restoration',
    description:
      'Barns, trailers, gooseneck decks, and railings straightened, re-braced, and re-welded with new steel where it counts.',
    icon: 'wrench',
    points: ['Column & beam repair', 'Trailer & deck rebuilds', 'Rust cut-out & replacement']
  }
]

export const stats = [
  { value: '10+', label: 'Years On The Torch' },
  { value: '1,200+', label: 'Jobs Completed' },
  { value: '60mi', label: 'Mobile Service Radius' },
  { value: '24/7', label: 'Emergency Repairs' }
]

/* PLACEHOLDER CONTENT — replace with real project photos and captions. */
export const gallery = [
  {
    src: images.gate,
    title: 'Ranch Entry & Pipe Fence',
    category: 'Entryways',
    span: 'wide' as const
  },
  { src: images.weldTee, title: 'Pipe Tee Joint', category: 'Fabrication', span: 'tall' as const },
  { src: images.bucket, title: 'Bucket Tooth Rebuild', category: 'Equipment Repair', span: 'normal' as const },
  { src: images.weldElbow, title: 'Brace Weld', category: 'Fence Work', span: 'normal' as const },
  { src: images.weldBead, title: 'Structural Fillet Pass', category: 'Structural', span: 'normal' as const },
  { src: images.railing, title: 'Porch Handrail', category: 'Restoration', span: 'normal' as const }
]

export const process = [
  {
    step: '01',
    title: 'Call or Text',
    body: 'Tell us what broke or what you want built. Photos help — send them straight to the shop.'
  },
  {
    step: '02',
    title: 'Straight Quote',
    body: 'You get a clear price and a real timeline. No hourly surprises, no vague estimates.'
  },
  {
    step: '03',
    title: 'We Roll Out',
    body: 'The rig shows up on time with the steel and gas needed to finish the job in one trip.'
  },
  {
    step: '04',
    title: 'Welded Right',
    body: 'Every joint gets cleaned, checked, and coated. We stand behind the bead we lay.'
  }
]

/* PLACEHOLDER CONTENT — confirm the final list of towns and counties served. */
export const serviceAreas = {
  primary: ['Gatesville', 'Waco', 'Copperas Cove', 'Killeen', 'Temple', 'McGregor'],
  extended: [
    'Hamilton',
    'Clifton',
    'Valley Mills',
    'China Spring',
    'Belton',
    'Harker Heights',
    'Crawford',
    'Evant',
    'Oglesby',
    'Moody'
  ],
  counties: ['Coryell', 'McLennan', 'Bell', 'Hamilton', 'Bosque']
}

/* PLACEHOLDER CONTENT — replace with real customer reviews. */
export const testimonials = [
  {
    quote:
      'Jason built our ranch entry and 400 feet of pipe fence. Showed up when he said he would and the welds look better than anything else on the road.',
    name: 'Dale R.',
    detail: 'Ranch Owner · Coryell County'
  },
  {
    quote:
      'Cracked the loader bucket mid-harvest. He drove out the same day and had us running before dark. Fair price, no runaround.',
    name: 'Marcus T.',
    detail: 'Row Crop Farmer · McLennan County'
  },
  {
    quote:
      'Rebuilt the deck on our gooseneck and repaired two barn columns. Clean work, straight talk. Only welder we call now.',
    name: 'Kimberly S.',
    detail: 'Repeat Customer · Bell County'
  }
]

export const trustPoints = [
  'Licensed & Insured',
  'Mobile Rig — We Come To You',
  'Free On-Site Estimates',
  'Locally Owned Since 2016'
]
